<template>
  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">
    <div class="popup-cont"
         tabindex="1">
      <h2 class="popup-heading">{{ setup ? "Confirm" : "Decline" }} Reservation</h2>
      <div class="popup-item" v-if="!setup">
        <h4>Confirm Cancellation</h4>
        <p>Please state your reason below.</p>
        <textarea class="pop-textarea"
                  placeholder="Reason"
                  v-model="reason" name="Reason" v-validate="'required'"></textarea>
        <span class="text-danger text-sm" v-show="errors.has('Reason')">{{ errors.first('Reason') }}</span>
      </div>
      <div v-else class="popup-item">
        <h4>Confirm Reservation</h4>
        <p>Please confirm by selecting Confirm Reservation button below.</p>

      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" @click="submitData">{{ this.setup === true ? "Confirm" : "Decline" }} Reservation</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    setup: {
      type: Boolean
    },
    end: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      reason: ''
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        return
      }
      return true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    initValues () {
      this.reason = ''
    },

    submitData () {
      if (!this.setup) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.end(this.setup, this.reason)
            this.isSidebarActiveLocal = false
          }
        })
      } else {
        this.end(this.setup)
        this.isSidebarActiveLocal = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .popup-cont {
    height: auto !important;
    overflow: hidden;
  }
</style>
